module.exports = __webpack_public_path__ + "img/compass.bb4351b0.svg";